<template>
  <div>

    <div class="d-flex justify-space-between mb-5">
      <div>
        <div class="page-title mb-2">
          โครงการหลัก
        </div>
        <div class="d-flex align-center font-type-bold txt-head black--text">
          <Iconify
              icon="ion:cube"
              color="var(--theme-color-one)"
              class="mr-3"
          ></Iconify>
          โครงการที่เปิดรับ
        </div>
      </div>

      <div class="d-flex flex-column gap-12">
        <div class="d-flex gap-12">
          <div class="flex-center" style="max-width: 250px">
            <div class="min-width-max">สถานะ</div>
            <SelectBox
                placeholder="สถานะ"
                hide-details
                clearable
                :items="statusMaster"
                @onChange="searchData.status = $event; getProjects()"
            ></SelectBox>
          </div>

          <div style="max-width: 250px">
            <TextField
                hide-details
                placeholder="ค้นหา"
                append-inner-icon="search"
                @onChange="searchData.keyword = $event"
                @onEnter="getProjects()"
            ></TextField>
          </div>
        </div>

        <div class="d-flex justify-end">
          <Button
              @onClick="createProject"
          >
            สร้างโครงการ
          </Button>
        </div>
      </div>
    </div>

    <div>
      <div class="d-flex justify-space-between table-head">
        <div
            v-for="(item, i) in tableHeader"
            :key="i"
            :style="{ 'width': item.width }"
        >
          {{ item.name }}
        </div>
      </div>

      <div class="list-layout">
        <MainProjectItem
            v-for="(item, i) in plans"
            :key="i"
            :item="item"
            :index="i"
            :headers="tableHeader"
        ></MainProjectItem>
      </div>

      <v-pagination
          class="mt-6"
          v-model="paginate.current_page"
          :length="paginate.last_page"
          color="#DE7033"
          @input="getProjects"
      ></v-pagination>
    </div>

  </div>
</template>

<script>
import TextField from "../../components/input/TextField"
import Button from "../../components/input/Button"
import SelectBox from "../../components/input/SelectBox"
import MainProjectItem from "../../components/MainProjectItem"

export default {
  name: "MainProject",
  components: {
    TextField,
    SelectBox,
    MainProjectItem,
    Button
  },
  data () {
    return {
      tableHeader: [
        {
          name: '',
          width: '6%'
        },
        {
          name: 'ลำดับ',
          width: '6%'
        },
        {
          name: 'ปี งปม.',
          width: '8%'
        },
        {
          name: 'ชื่อโครงการหลัก',
          width: '60%'
        },
        {
          name: 'สถานะ',
          width: '20%'
        }
      ],
      plans: [],
      statusMasterEN: [
          'Draft',
          'Inactive',
          'Active',
      ],
      statusMaster: [
          'ฉบับร่าง',
          'ปิดรับโครงการ',
          'เปิดรับโครงการ',
      ],
      searchData: {
        status: null,
        keyword: null
      },
      paginate: {
        total: 1,
        per_page: 1,
        current_page: 1,
        last_page: 1,
      },
    }
  },
  created () {
    this.getProjects()
  },
  methods: {
    createProject () {
      this.$router.push({ name: 'MainProjectForm' })
    },
    async getProjects (page) {
      let payload = {
        page: page,
        status: this.searchData.status ? this.returnStatus(this.searchData.status) : this.statusMasterEN.join(','),
        keyword: this.searchData.keyword
      };

      let res = await this.$apiFire('MainProject/getMainProjects', payload)
      console.log(res)
      this.plans = res.data.map((item, index) => {
        return {
          ...item,
          no: (res.current_page - 1) * res.per_page + index + 1
        }
      });
      this.paginate = {
        total: res.total,
        per_page: res.per_page,
        current_page: res.current_page,
        last_page: res.last_page,
      };
    },
    returnStatus(status) {
      switch (status) {
        case "ฉบับร่าง":
          return "Draft";

        case "ปิดรับโครงการ":
          return "Inactive";

        case "เปิดรับโครงการ":
          return "Active";

        default:
          return "-";
      }
    },
  }
}
</script>

<style scoped lang="scss">
.table-head {
  padding: 0 33px 0 36px;
  margin-bottom: 12px;
  gap: 8px;
}

.list-layout {
  display: flex;
  flex-direction: column;
  gap: 12px;
}
</style>